export class Challenges {
	static readonly CHALLENGE_NAME_MFA_SETUP = 'MFA_SETUP';
	static readonly CHALLENGE_NAME_NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
	static readonly CHALLENGE_NAME_SMS_MFA = 'SMS_MFA';
	static readonly CHALLENGE_NAME_SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';
}
